function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M504.498,497h-12.031L360.273,245.205c-0.01-0.02-0.021-0.039-0.031-0.059l-39.621-75.467 c-1.296-2.468-3.854-4.014-6.641-4.014s-5.345,1.546-6.641,4.014l-26.031,49.585l-51.792-99.267 c-1.293-2.478-3.855-4.031-6.649-4.031s-5.356,1.553-6.649,4.031l-65.293,125.144c-0.013,0.024-0.025,0.048-0.038,0.072 L19.521,497H7.503c-4.143,0-7.5,3.358-7.5,7.5c0,4.142,3.357,7.5,7.5,7.5h66.957c4.143,0,7.5-3.358,7.5-7.5 c0-4.142-3.357-7.5-7.5-7.5H36.44l123.031-235.808l33.244,33.244c1.407,1.407,3.314,2.197,5.304,2.197s3.896-0.79,5.304-2.197 l36.11-36.112l19.548,19.546c2.928,2.929,7.677,2.929,10.606,0l16.678-16.678l0.661,1.266c0.009,0.018,0.019,0.036,0.028,0.054 l41.631,79.792c1.916,3.672,6.448,5.095,10.118,3.18c3.673-1.916,5.097-6.446,3.181-10.119l-39.107-74.955l2.086-2.086 l19.548,19.546c1.464,1.465,3.384,2.197,5.303,2.197s3.839-0.732,5.304-2.197l16.698-16.698L475.524,497H362.899v-18.138h25.634 c2.488,0,4.815-1.234,6.211-3.295c1.395-2.061,1.677-4.68,0.753-6.99l-12.454-31.128h5.49c2.539,0,4.905-1.284,6.289-3.413 c1.383-2.129,1.596-4.813,0.564-7.133l-33.135-74.548c-1.204-2.708-3.89-4.454-6.854-4.454s-5.649,1.746-6.854,4.454 l-33.132,74.548c-1.031,2.32-0.818,5.004,0.564,7.133c1.384,2.129,3.75,3.413,6.289,3.413h5.489L315.3,468.577 c-0.924,2.31-0.642,4.929,0.753,6.99c1.396,2.061,3.723,3.295,6.211,3.295h25.633V497H164.101v-18.138h25.634 c2.488,0,4.815-1.234,6.211-3.295c1.395-2.061,1.677-4.68,0.753-6.99l-12.454-31.128h5.49c2.539,0,4.905-1.284,6.289-3.413 c1.383-2.129,1.596-4.813,0.564-7.133l-33.135-74.548c-1.204-2.708-3.89-4.454-6.854-4.454s-5.649,1.746-6.854,4.454 l-33.132,74.548c-1.031,2.32-0.818,5.004,0.564,7.133c1.384,2.129,3.75,3.413,6.289,3.413h5.489l-12.453,31.128 c-0.924,2.31-0.642,4.929,0.753,6.99c1.396,2.061,3.723,3.295,6.211,3.295h25.635V497h-44.673c-4.143,0-7.5,3.358-7.5,7.5 c0,4.142,3.357,7.5,7.5,7.5h400.07c4.143,0,7.5-3.358,7.5-7.5C511.997,500.358,508.641,497,504.498,497z M264.283,261.96 l-19.548-19.546c-2.928-2.93-7.677-2.929-10.606,0l-36.11,36.112l-31.274-31.274l56.124-107.57l56.124,107.57L264.283,261.96z M329.711,261.96l-19.548-19.546c-1.406-1.407-3.313-2.197-5.303-2.197c-1.99,0-3.896,0.79-5.304,2.197l-4.055,4.056l-0.656-1.258 c-0.012-0.023-0.024-0.046-0.036-0.068l-5.057-9.693l24.228-46.15l30.43,57.961L329.711,261.96z M134.548,463.862l12.453-31.128 c0.922-2.31,0.64-4.929-0.754-6.99c-1.396-2.061-3.723-3.295-6.211-3.295h-5.026l21.591-48.582l21.594,48.582h-5.027 c-2.488,0-4.815,1.234-6.211,3.295c-1.395,2.061-1.677,4.68-0.753,6.99l12.454,31.128H134.548z M333.346,463.862l12.453-31.128 c0.923-2.31,0.641-4.929-0.754-6.99c-1.396-2.061-3.723-3.295-6.211-3.295h-5.026l21.591-48.582l21.594,48.582h-5.027 c-2.488,0-4.815,1.234-6.211,3.295c-1.395,2.061-1.677,4.68-0.753,6.99l12.454,31.128H333.346z"
})));

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M297.417,0C270.443,0,248.5,21.944,248.5,48.918c0,26.973,21.944,48.917,48.917,48.917 c26.974,0,48.918-21.944,48.918-48.917C346.333,21.944,324.39,0,297.417,0z M297.417,82.835 c-18.702,0-33.917-15.215-33.917-33.917C263.5,30.215,278.714,15,297.417,15c18.702,0,33.918,15.215,33.918,33.918 C331.334,67.62,316.118,82.835,297.417,82.835z"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M206.3,91.118h-26.336c-3.53-18.834-20.086-33.134-39.928-33.134c-6.079,0-11.996,1.338-17.404,3.908 C113.75,54.083,102.277,49.7,90.334,49.7C65.91,49.7,45.61,67.692,41.99,91.118H24.07c-4.143,0-7.5,3.358-7.5,7.5 c0,4.142,3.357,7.5,7.5,7.5h49.698c4.143,0,7.5-3.358,7.5-7.5c0-4.142-3.357-7.5-7.5-7.5H57.261 C60.686,76.014,74.209,64.7,90.334,64.7c9.717,0,18.986,4.188,25.432,11.491c2.501,2.835,6.723,3.365,9.85,1.233 c4.259-2.905,9.245-4.44,14.42-4.44c11.526,0,21.297,7.648,24.512,18.134H156.6c-4.143,0-7.5,3.358-7.5,7.5 c0,4.142,3.357,7.5,7.5,7.5H206.3c4.143,0,7.5-3.358,7.5-7.5C213.8,94.476,210.443,91.118,206.3,91.118z"
})));

var _ref4 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M496.215,124.253h-26.336c-3.53-18.834-20.086-33.134-39.928-33.134c-6.079,0-11.997,1.338-17.404,3.908 c-8.881-7.809-20.354-12.192-32.297-12.192c-24.425,0-44.724,17.992-48.344,41.417h-17.921c-4.143,0-7.5,3.358-7.5,7.5 c0,4.142,3.357,7.5,7.5,7.5h49.697c4.143,0,7.5-3.358,7.5-7.5c0-4.142-3.357-7.5-7.5-7.5h-16.505 c3.424-15.104,16.947-26.417,33.072-26.417c9.717,0,18.986,4.188,25.432,11.491c2.503,2.835,6.724,3.365,9.85,1.233 c4.258-2.905,9.245-4.44,14.42-4.44c11.526,0,21.297,7.647,24.512,18.134h-7.947c-4.143,0-7.5,3.358-7.5,7.5s3.357,7.5,7.5,7.5 h49.699c4.143,0,7.5-3.358,7.5-7.5C503.715,127.611,500.358,124.253,496.215,124.253z"
})));

var _ref5 =
/*#__PURE__*/
React.createElement("g", null);

var _ref6 =
/*#__PURE__*/
React.createElement("g", null);

var _ref7 =
/*#__PURE__*/
React.createElement("g", null);

var _ref8 =
/*#__PURE__*/
React.createElement("g", null);

var _ref9 =
/*#__PURE__*/
React.createElement("g", null);

var _ref10 =
/*#__PURE__*/
React.createElement("g", null);

var _ref11 =
/*#__PURE__*/
React.createElement("g", null);

var _ref12 =
/*#__PURE__*/
React.createElement("g", null);

var _ref13 =
/*#__PURE__*/
React.createElement("g", null);

var _ref14 =
/*#__PURE__*/
React.createElement("g", null);

var _ref15 =
/*#__PURE__*/
React.createElement("g", null);

var _ref16 =
/*#__PURE__*/
React.createElement("g", null);

var _ref17 =
/*#__PURE__*/
React.createElement("g", null);

var _ref18 =
/*#__PURE__*/
React.createElement("g", null);

var _ref19 =
/*#__PURE__*/
React.createElement("g", null);

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    version: 1.1,
    id: "Capa_1",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      "enableBackground": "new 0 0 512 512"
    },
    xmlSpace: "preserve"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19);
};

export default __webpack_public_path__ + "static/media/mountain.cd03f49d.svg";
export { SvgComponent as ReactComponent };